import { render, staticRenderFns } from "./SocietyMatchesView.vue?vue&type=template&id=53e04bf7&scoped=true"
import script from "./SocietyMatchesView.vue?vue&type=script&lang=js"
export * from "./SocietyMatchesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e04bf7",
  null
  
)

export default component.exports